
const Constants = {
   AddTags: 'wst_addTag',
   RemoveTag: 'wst_removeTag',
   SetTagList: 'wst_setTagList',
   SetFilterList: 'wst_setFilterList',
};

exports.Reducer = (state={},action) =>{
   switch(action.type){
      case Constants.AddTags:{
         if(action.tags.length === 0)
            return state;

         let tags = state.tagList.slice();
         for(let toInsert of action.tags){
            if(toInsert.trim() === '')
               continue;

            let tagExists = false;
            for(let tag of tags){
               if(tag === toInsert)
                  tagExists = true;
            }
            if(!tagExists)
               tags.push(toInsert);
         }

         return {...state, tagList: tags};
      }
      case Constants.RemoveTag: {
         let tags = state.tagList.slice();
         for(let i = 0; i < tags.length; i++){
            if(tags[i] === action.tag){
               tags.splice(i,1);
            }
         }
         return {...state, tagList: tags};
      }
      case Constants.SetTagList:
         return {...state, tagList: action.tagList};
      case Constants.SetFilterList:
         return {...state, filterList: action.filterList};
      default:
         return state;
   }
};

const FunctionList = {};

FunctionList.addTags = (tags) => {
   return{
      type: Constants.AddTags,
      tags
   }
};

FunctionList.removeTag = (tag) => {
   return{
      type: Constants.RemoveTag,
      tag
   }
};

FunctionList.setTagList = (tagList) => {
   return{
      type: Constants.SetTagList,
      tagList
   }
};

FunctionList.setFilterList = (filterList) => {
   return{
      type: Constants.SetFilterList,
      filterList
   }
};

exports.FunctionList = FunctionList;
